import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

i18n
  // Dil algılama eklentisi
  .use(LanguageDetector)
  // React için i18next başlatıcı
  .use(initReactI18next)
  // i18next başlatma
  .init({
    fallbackLng: "tr",
    debug: false,

    // Tarayıcı dil algılama ayarları
    detection: {
      // Öncelik sırası değiştirildi
      order: ["localStorage", "cookie", "navigator", "htmlTag"],
      lookupQuerystring: "lng",
      lookupCookie: "i18next",
      lookupLocalStorage: "i18nextLng",
      caches: ["localStorage", "cookie"],
    },

    // Çeviriler yükleme türü
    backend: {
      loadPath: "/locales/{{lng}}/translation.json",
    },

    interpolation: {
      escapeValue: false, // React zaten XSS koruması sağlıyor
    },

    // Varsayılan dil ayarı - her zaman Türkçe ile başla
    lng: "tr",

    // Varsayılan çeviriler (projeyi başlatırken sayfada görünecek bazı metinler için)
    // Sonradan public/locales klasöründeki çeviri dosyalarından yüklenecek
    resources: {
      tr: {
        translation: {
          nav: {
            home: "Ana Sayfa",
            about: "Kurumsal",
            products: "Ürünlerimiz",
            services: "Hizmetlerimiz",
            references: "Referanslar",
            contact: "İletişim",
            getQuote: "Teklif Al",
            menu: "Menü",
            phone: "Telefon",
            email: "E-posta",
            address: "Adres",
            contactUs: "Bize Ulaşın",
          },
          footer: {
            contact: "İletişim Bilgileri",
            workingHours: "Çalışma Saatleri",
            rights: "Tüm Hakları Saklıdır",
          },
          products: {
            wheat: "Buğday",
            barley: "Arpa",
            corn: "Mısır",
            cornOil: "Mısır Yağı",
            sunflowerOil: "Ayçiçek Yağı",
            fertilizer: "Gübre",
            chicken: "Tavuk", // Yeni eklenen tavuk çevirisi
            details: "Detaylar",
            getQuote: "Teklif Al",
            viewAll: "Tüm Ürünleri İncele",
          },
          form: {
            quoteTitle: "Teklif Formu",
            quoteDescription:
              "Aşağıdaki formu doldurarak ürünlerimiz hakkında teklif alabilirsiniz. En kısa sürede size dönüş yapacağız.",
            fullName: "Adınız Soyadınız",
            companyName: "Firma Adı/Ünvanı",
            city: "Şehir",
            country: "Ülke",
            phone: "Telefon",
            email: "E-posta",
            website: "Web Sitesi",
            product: "Ürün",
            productInfo: "Ürün Bilgileri",
            quantity: "Miktar (Ton)",
            requestedDate: "Talep Edilen Tarih",
            detail: "Detay",
            send: "Gönder",
            successMessage: "Form başarı ile gönderildi.",
            errorMessage: "Form gönderilirken bir hata oluştu.",
            selectProduct: "Ürün Seçiniz", // Dropdown için placeholder
            personalInfo: "Kişisel Bilgiler", // Kişisel bilgiler başlığı
          },
          home: {
            products: "Ürünlerimiz",
            productsSubtitle:
              "Yüksek kaliteli tarım ürünleri ve bitkisel yağlar",
            aboutTitle: "Dünya Ticaretinde Güvenilir Ortağınız",
            aboutText1:
              "SGT Dış Ticaret Ltd. Şti. olarak, tarım ürünleri ve bitkisel yağlar alanında uzmanlaşmış bir dış ticaret şirketiyiz. Müşterilerimize en kaliteli ürünleri, rekabetçi fiyatlarla ve güvenilir tedarik zincirimiz ile sunuyoruz.",
            aboutText2:
              "Global pazarda yılların deneyimi ile müşterilerimizin ihtiyaçlarını anlıyor ve onlara özel çözümler sunuyoruz. Yüksek kalite standartlarımız, güvenilir tedarik ağımız ve müşteri memnuniyetine odaklanan yaklaşımımız ile dünya çapında tercih edilen bir iş ortağıyız.",
            learnMore: "Daha Fazla Bilgi",
            getQuoteTitle: "Hemen Teklif Alın",
            getQuoteText:
              "Ürünlerimiz hakkında detaylı bilgi ve fiyat teklifi almak için formu doldurun, uzman ekibimiz en kısa sürede sizinle iletişime geçsin.",
            contactTitle: "İletişim",
            contactSubtitle: "Sorularınız için bizimle iletişime geçin",
            phone: "Telefon",
            email: "E-posta",
            contactUs: "Bize Ulaşın",
            scrollDown: "Aşağı Kaydır",
          },
          quote: {
            title: "Teklif Alın",
            description:
              "Ürünlerimiz hakkında detaylı bilgi ve fiyat teklifi almak için yanındaki formu doldurabilirsiniz. Uzman ekibimiz en kısa sürede sizinle iletişime geçecektir.",
            whyChooseUs: "Neden Bizi Tercih Etmelisiniz?",
            benefit1: "Premium kalitede tarım ürünleri ve bitkisel yağlar",
            benefit2: "Rekabetçi fiyatlar ve esneklik",
            benefit3: "Güvenilir ve zamanında teslimat",
            benefit4: "Uluslararası ticaret tecrübesi",
            benefit5: "Kişiselleştirilmiş müşteri hizmeti",
            contactInfo: "İletişim Bilgilerimiz",
            address: "Adres:",
            phone: "Telefon:",
            email: "E-posta:",
            workingHours: "Çalışma Saatleri:",
          },
          about: {
            title: "Hakkımızda",
            subtitle: "1999'dan Beri Güvenilir Ticaret Ortağınız",
            history: {
              title: "Şirket Tarihimiz",
              paragraph1:
                "1999 yılında temelleri atılan Safe Global Trade, tarım ürünleri ticareti alanında lider bir kuruluş olarak yolculuğuna başladı.",
              paragraph2:
                "Yıllar içinde sürekli büyüyen şirketimiz, dünya çapında güvenilir tedarik zinciri çözümleri sunarak küresel pazarda önemli bir oyuncu haline geldi.",
              paragraph3:
                "Bugün, 40'tan fazla ülkeye ihracat yapan şirketimiz, müşterilerimize en kaliteli ürünleri sunmak için çalışmaktadır.",
            },
            quickFacts: {
              title: "Hızlı Bilgiler",
              founded: "Kuruluş Yılı",
              employees: "Çalışan Sayısı",
              operations: "Operasyon Alanları",
              operationsDesc: "Tarım Ürünleri, Gıda, Lojistik",
              specialization: "Uzmanlık",
              specializationDesc: "Tahıl, Yağ ve Gübre Ticareti",
            },
            mission: {
              title: "Misyonumuz",
              description:
                "Yüksek kaliteli tarım ürünlerini, güvenilir ve sürdürülebilir tedarik zinciri çözümleriyle dünya pazarlarına ulaştırmak, müşterilerimizin başarısına katkıda bulunmak.",
            },
            vision: {
              title: "Vizyonumuz",
              description:
                "Küresel tarım ticaretinde öncü ve yenilikçi bir şirket olarak, gıda güvenliğine katkıda bulunmak ve sürdürülebilir tarım uygulamalarını destekleyerek dünya ticaretinde örnek bir kuruluş olmak.",
            },
            values: {
              title: "Değerlerimiz",
              subtitle:
                "Başarımızın temeli olan değerlerimiz, her kararımızda ve işimizin her aşamasında bize rehberlik etmektedir.",
              quality: {
                title: "Kalite",
                desc: "En yüksek standartlarda ürün ve hizmet sunmayı taahhüt ediyoruz.",
              },
              integrity: {
                title: "Dürüstlük",
                desc: "Tüm iş ilişkilerimizde şeffaflık ve dürüstlük prensibiyle hareket ediyoruz.",
              },
              customer: {
                title: "Müşteri Odaklılık",
                desc: "Müşterilerimizin ihtiyaçlarını anlamak ve aşmak için çalışıyoruz.",
              },
              innovation: {
                title: "Yenilikçilik",
                desc: "Sürekli gelişim ve yenilikçi çözümlerle sektörde fark yaratıyoruz.",
              },
            },
            stats: {
              years: "Yıllık Tecrübe",
              countries: "İhracat Ülkesi",
              clients: "Kurumsal Müşteri",
              tons: "Yıllık Ticaret Hacmi (Ton)",
            },
            timeline: {
              title: "Tarihçemiz",
              subtitle:
                "1999'dan günümüze Safe Global Trade'in büyüme ve gelişim yolculuğu.",
              founding: "Şirketin Kuruluşu",
              foundingDesc:
                "Safe Global Trade, İstanbul'da tarım ürünleri ticareti yapmak üzere kuruldu.",
              expansion: "Yurt İçi Genişleme",
              expansionDesc:
                "Türkiye genelinde operasyonlarımızı genişleterek ülkenin önde gelen tedarikçilerinden biri haline geldik.",
              international: "Uluslararası Pazarlara Açılma",
              internationalDesc:
                "İlk uluslararası ofisimizi açarak global pazarlarda varlığımızı güçlendirdik.",
              technology: "Teknolojik Yatırımlar",
              technologyDesc:
                "Tedarik zinciri optimizasyonu için ileri teknoloji sistemleri ve yazılımlar entegre ettik.",
              sustainability: "Sürdürülebilirlik İnisiyatifleri",
              sustainabilityDesc:
                "Çevre dostu operasyonlar ve sürdürülebilir tarım uygulamaları için projeler başlattık.",
              present: "Bugün",
              presentDesc:
                "40'tan fazla ülkeye ihracat yapan, güvenilir ve global bir ticaret ortağı olarak faaliyetlerimizi sürdürüyoruz.",
            },
          },
        },
      },
      en: {
        translation: {
          nav: {
            home: "Home",
            about: "About Us",
            products: "Our Products",
            services: "Our Services",
            references: "References",
            contact: "Contact",
            getQuote: "Get Quote",
            menu: "Menu",
            phone: "Phone",
            email: "Email",
            address: "Address",
            contactUs: "Contact Us",
          },
          footer: {
            contact: "Contact Information",
            workingHours: "Working Hours",
            rights: "All Rights Reserved",
          },
          products: {
            wheat: "Wheat",
            barley: "Barley",
            corn: "Corn",
            cornOil: "Corn Oil",
            sunflowerOil: "Sunflower Oil",
            fertilizer: "Fertilizer",
            chicken: "Chicken", // Yeni eklenen tavuk çevirisi
            details: "Details",
            getQuote: "Get Quote",
            viewAll: "View All Products",
          },
          form: {
            quoteTitle: "Quote Form",
            quoteDescription:
              "Fill out the form below to get a quote for our products. We will get back to you as soon as possible.",
            fullName: "Full Name",
            companyName: "Company Name/Title",
            city: "City",
            country: "Country",
            phone: "Phone",
            email: "Email",
            website: "Website",
            product: "Product",
            productInfo: "Product Information",
            quantity: "Quantity (Tons)",
            requestedDate: "Requested Date",
            detail: "Details",
            send: "Send",
            successMessage: "Form has been sent successfully.",
            errorMessage: "An error occurred while sending the form.",
            selectProduct: "Select Product", // Dropdown için placeholder
            personalInfo: "Personal Information", // Kişisel bilgiler başlığı
          },
          home: {
            products: "Our Products",
            productsSubtitle:
              "High quality agricultural products and vegetable oils",
            aboutTitle: "Your Reliable Partner in Global Trade",
            aboutText1:
              "As SGT Global Trade, we are a foreign trade company specializing in agricultural products and vegetable oils. We offer our customers the highest quality products at competitive prices with our reliable supply chain.",
            aboutText2:
              "With years of experience in the global market, we understand our customers' needs and offer customized solutions. With our high quality standards, reliable supply network and customer satisfaction-focused approach, we are a preferred business partner worldwide.",
            learnMore: "Learn More",
            getQuoteTitle: "Get a Quote Now",
            getQuoteText:
              "Fill out the form to get detailed information and price quotes about our products, and our expert team will contact you as soon as possible.",
            contactTitle: "Contact Us",
            contactSubtitle: "Get in touch with us for your questions",
            phone: "Phone",
            email: "Email",
            contactUs: "Contact Us",
            scrollDown: "Scroll Down",
          },
          quote: {
            title: "Get a Quote",
            description:
              "You can fill out the form on the right to get detailed information and price quotes about our products. Our expert team will contact you as soon as possible.",
            whyChooseUs: "Why Choose Us?",
            benefit1:
              "Premium quality agricultural products and vegetable oils",
            benefit2: "Competitive prices and flexibility",
            benefit3: "Reliable and timely delivery",
            benefit4: "International trade experience",
            benefit5: "Personalized customer service",
            contactInfo: "Our Contact Information",
            address: "Address:",
            phone: "Phone:",
            email: "Email:",
            workingHours: "Working Hours:",
          },
          about: {
            title: "About Us",
            subtitle: "Your Trusted Trading Partner Since 1999",
            history: {
              title: "Our Company History",
              paragraph1:
                "Founded in 1999, Safe Global Trade began its journey as a leading organization in the agricultural products trade.",
              paragraph2:
                "Over the years, our continuously growing company has become a significant player in the global market by providing reliable supply chain solutions worldwide.",
              paragraph3:
                "Today, our company exports to more than 40 countries, working to provide our customers with the highest quality products.",
            },
            quickFacts: {
              title: "Quick Facts",
              founded: "Founded",
              employees: "Employees",
              operations: "Operations",
              operationsDesc: "Agricultural Products, Food, Logistics",
              specialization: "Specialization",
              specializationDesc: "Grain, Oil and Fertilizer Trade",
            },
            mission: {
              title: "Our Mission",
              description:
                "To deliver high-quality agricultural products to world markets through reliable and sustainable supply chain solutions, contributing to the success of our customers.",
            },
            vision: {
              title: "Our Vision",
              description:
                "To be an exemplary organization in world trade as a leading and innovative company in global agricultural trade, contributing to food security and supporting sustainable agricultural practices.",
            },
            values: {
              title: "Our Values",
              subtitle:
                "Our values, which are the foundation of our success, guide us in every decision and at every stage of our business.",
              quality: {
                title: "Quality",
                desc: "We are committed to providing the highest standard products and services.",
              },
              integrity: {
                title: "Integrity",
                desc: "We act with transparency and honesty in all our business relationships.",
              },
              customer: {
                title: "Customer Focus",
                desc: "We work to understand and exceed our customers' needs.",
              },
              innovation: {
                title: "Innovation",
                desc: "We make a difference in the industry with continuous improvement and innovative solutions.",
              },
            },
            stats: {
              years: "Years of Experience",
              countries: "Export Countries",
              clients: "Corporate Clients",
              tons: "Annual Trade Volume (Tons)",
            },
            timeline: {
              title: "Our Timeline",
              subtitle:
                "Safe Global Trade's journey of growth and development from 1999 to the present.",
              founding: "Company Foundation",
              foundingDesc:
                "Safe Global Trade was established in Istanbul to trade agricultural products.",
              expansion: "Domestic Expansion",
              expansionDesc:
                "We expanded our operations throughout Turkey, becoming one of the country's leading suppliers.",
              international: "International Market Entry",
              internationalDesc:
                "We opened our first international office, strengthening our presence in global markets.",
              technology: "Technological Investments",
              technologyDesc:
                "We integrated advanced technology systems and software for supply chain optimization.",
              sustainability: "Sustainability Initiatives",
              sustainabilityDesc:
                "We launched projects for environmentally friendly operations and sustainable agricultural practices.",
              present: "Today",
              presentDesc:
                "We continue our operations as a reliable and global trading partner exporting to more than 40 countries.",
            },
          },
        },
      },
    },
  });

// Sayfa yüklendiğinde Türkçe dil ayarını zorla
localStorage.setItem("i18nextLng", "tr");
i18n.changeLanguage("tr");

export default i18n;
